import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet } from 'react-router-dom';
import './App.css';

// Layout Components
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

// Section Components
import Hero from './components/sections/Hero';
import HowItWorks from './components/sections/HowItWorks';
import EcoregionCallout from './components/sections/EcoregionCallout';
import JoinCult from './components/sections/JoinCult';
import TrophyClub from './components/sections/TrophyClub';
import Newsletter from './components/sections/Newsletter';

// Page Components
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import PasswordlessWaitingPage from './pages/PasswordlessWaitingPage';
import ConfirmEmailPage from './pages/ConfirmEmailPage';
import ProfilePage from './pages/ProfilePage';
import DesignPage from './pages/DesignPage';
import GalleryPage from './pages/GalleryPage';
import CreateDesignPage from './pages/CreateDesignPage';
import UserProfilePage from './pages/UserProfilePage';
import ProtectedRoute from './components/auth/ProtectedRoute';
import DesignDetailPage from './pages/DesignDetailPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import PlaygroundPage from './pages/PlaygroundPage';
import ConsultPage from './pages/ConsultPage';


// Utility Components
import ScrollToTop from './components/utils/ScrollToTop';

// Layout for authentication pages
const AuthLayout = () => (
  <>
    <Navbar />
    <Outlet />
  </>
);

// Main layout for marketing pages
const MainLayout = () => (
  <div className="App">
    <Navbar />
    <main>
      <Outlet /> 
    </main>
    <Footer />
  </div>
);

// Component for the marketing home page content
const HomePage = () => (
  <>
    <Hero />
    <HowItWorks />
    <EcoregionCallout />
    <TrophyClub />
    <JoinCult />
    <Newsletter />
  </>
);

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route element={<MainLayout />}>
          <Route path="/" element={<HomePage />} />
        </Route>
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/passwordless-waiting" element={<PasswordlessWaitingPage />} />
          <Route path="/confirm-email" element={<ConfirmEmailPage />} />
          <Route path="/terms" element={<TermsOfServicePage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/consult" element={<ConsultPage />} />

          <Route element={<ProtectedRoute />}>
            <Route path="/profile" element={<ProfilePage />} />
            <Route path="/design" element={<DesignPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/gallery/:designId" element={<DesignDetailPage />} />
            <Route path="/create-design" element={<CreateDesignPage />} />
            <Route path="/gallery/user/:userId" element={<UserProfilePage />} />
            <Route path="/playground" element={<PlaygroundPage />} />
          </Route>
        </Route>
        {/* Add other routes here */}
      </Routes>
    </Router>
  );
}

export default App;
